import { type FC } from "react";
import { Presentation } from "./Presentation";
import { useWorkDetailBottomButtons } from "./useWorkDetailBottomButtons";

type Props = {
  fetchUrl: string;
  fetchBody: Record<string, unknown>;
  recommendFetchUrl: string;
  createLineConsultButtonHistoryUrl: string;
  isShowLineConsultButton: boolean;
};

export const WorkDetailBottomButtons: FC<Props> = ({
  fetchUrl,
  fetchBody,
  recommendFetchUrl,
  createLineConsultButtonHistoryUrl,
  isShowLineConsultButton,
}) => {
  const formattedData = useWorkDetailBottomButtons({
    fetchUrl,
    fetchBody,
    recommendFetchUrl,
    createLineConsultButtonHistoryUrl,
    isShowLineConsultButton,
  });
  return formattedData ? <Presentation {...formattedData} /> : null;
};
